
import { BlogSection } from '@/types/blog';

export const umgebungSection: BlogSection = {
  id: 'umgebung',
  title: 'Umgebung als Katalysator für Veränderung',
  content: `
    <p>
      Die Umgebung kann ein wichtiger Katalysator für Veränderung sein. 
      Die Kombination aus <strong>Natur</strong>, <strong>Ruhe</strong> und <strong>inspiriender Atmosphäre</strong> schafft 
      Räume, in denen Reflexion und Wachstum besonders gut gelingen.
    </p>
    
    <p>
      Dies zeigt, dass Coaching überall dort wirksam sein kann, wo Menschen bereit sind, sich auf 
      Veränderung einzulassen – sei es in der Natur am Rothsee oder in einer intensiven Coaching-Sitzung, 
      die Klarheit in Finanzthemen bringt.
    </p>
  `
};
